module.exports = __webpack_public_path__ + "media/app/assets/images/fire-7b69803117193bb5a731cc18bd4f5bde.png";